import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=44cb3441&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports